
<template>
  <div class="PacienteDetalleCitas">
    <div id="card">
      <v-card
        outlined
        :disabled="cargando"
        :loading="cargando"
      >
        <v-card-title>
          Citas
          <v-spacer />
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            hide-details
          />
        </v-card-title>
        <v-data-table
          class="upper"
          :headers="headers"
          :items="citas"
          :search="search"
          :loading="cargando"
          loading-text="Cargando..."
        >
          <template v-slot:item.fecha="{ item }">
            {{
              $Datetime
                .fromSQL(item.fecha)
                .setLocale("es")
                .toLocaleString($Datetime.DATETIME_MED)
            }}
          </template>
          <template v-slot:item.estatus_cit="{ item }">
            <v-chip
              :color="item.color"
              dark
              small
            >
              {{ item.estatus_cit }}
            </v-chip>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>
<script>
import forms from "@/mixins/forms.js";
export default {
  name: "PacienteDetalleCitas",
  mixins: [forms],
  props: {
    id: [String, Number],
  },
  data() {
    return {
      search: "",
      headers: [
        { text: "Fecha", value: "fecha" },
        { text: "Médico encargado", value: "medico" },
        { text: "Estatus", value: "estatus_cit" },
      ],
      paciente: null,
      citas: [],
    };
  },
  methods: {
    _getCitas() {
      if (this.id) {
        this._getThings("citas/paciente/" + this.id, "citas");
      }
    },
  },
  created() {
    this.paciente = this.id;
    this._getCitas();
  },
  watch: {
    id() {
      this.paciente = this.id;
      this._getCitas();
    },
  },
};
</script>

